import * as Types from "../../../actions/actionTypes";

const startNumber = 8,
  endNumber = 13;
const initialState = {};

for (let i = startNumber; i < endNumber; i++) {
  initialState["vendorSalesChart" + i] = {
    loading: true,
    data: {
      chart_label: "",
      data: {},
      legends: [],
      chart_info: {
        chart_label: "",
        data: {},
      },
    },
    error: "",
  };
}

function vendorSalesChartReducer(state = initialState, action) {
  const newState = { ...state };

  for (let i = startNumber; i < endNumber; i++) {
    const chartNumber = "vendorSalesChart" + i;

    if (
      action.type ===
      Types.vendorSalesChartActionTypes[`VENDOR_SALES_CHART_${i}_DATA_LOADING`]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        loading: action.payload,
      };
      return newState;
    }
    if (
      action.type ===
      Types.vendorSalesChartActionTypes[`VENDOR_SALES_CHART_${i}_DATA_LOADED`]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        data: action.payload,
        error: "",
      };
      return newState;
    }
    if (
      action.type ===
      Types.vendorSalesChartActionTypes[
        `VENDOR_SALES_CHART_${i}_DATA_LOAD_ERROR`
      ]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        error: action.payload,
      };
      return newState;
    }
  }

  if (action.type === Types.RESET_VENDOR_SALES_CHART_DATA) {
    return initialState;
  }

  return state;
}

export default vendorSalesChartReducer;
